interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps) => {
  return (
    <div className="flex items-center justify-center mb-8">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((num) => (
        <div key={num} className="flex items-center flex-1 last:flex-none">
          <div
            className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300 ${
              num === currentStep
                ? 'bg-[#6366F1] text-white shadow-lg shadow-indigo-200'
                : num < currentStep
                ? 'bg-white text-[#6366F1] border-2 border-[#6366F1]'
                : 'bg-white text-gray-400 border-2 border-gray-200'
            }`}
          >
            {num}
          </div>
          {num < totalSteps && (
            <div className="h-[2px] flex-1 mx-1 sm:mx-2">
              <div
                className={`h-full transition-all duration-300 ${
                  num < currentStep ? 'bg-[#6366F1]' : 'bg-gray-200'
                }`}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};